/*
 * Technical skills organized by what they are actually used for.
 * No icon grid. Displayed as plain-text domain groups.
 */
export const skillsData = {
    groups: [
        {
            domain: 'Infrastructure and Cloud',
            skills: ['AWS (EC2, S3, Lambda, RDS, CloudWatch)', 'Terraform', 'Docker', 'Linux', 'Jenkins', 'CI/CD pipelines']
        },
        {
            domain: 'Backend and Data',
            skills: ['Python', 'Django', 'Flask', 'PostgreSQL', 'MySQL', 'Redis', 'Elasticsearch', 'Pandas', 'ETL design']
        },
        {
            domain: 'Frontend and APIs',
            skills: ['React', 'JavaScript', 'TypeScript', 'Node.js', 'GraphQL', 'REST APIs', 'HTML/CSS']
        },
        {
            domain: 'Tooling and Testing',
            skills: ['Git', 'Selenium', 'BeautifulSoup', 'HuggingFace Transformers', 'GCP']
        }
    ]
}